import {createReducer, on} from "@ngrx/store";
import {TechInfoState} from "@tech/pages/infos/store/tech-info.state";
import {TechInfosActions} from './tech-info.actions-type';
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";

function getInitialInfosSate(): TechInfoState {
  const env = CoreEnvironmentService.getEnvironment();
  return {
    infoList: [],
    paging: {
      totalItems: 0,
      pageNumber: 0,
      pageSize: env?.apiUrl?.pageDefaultSize || 50,
      totalPages: 1
    },
    isLoading: true,
    isLoadingId: NaN
  }
}

export const techInfosStore = createReducer(
  getInitialInfosSate(),
  on(TechInfosActions.getInfoList, (state) => ({
    ...state,
    isLoading: true
  })),
  on(TechInfosActions.getInfoListCancel, (state) => ({
    ...state,
    isLoading: false
  })),
  on(TechInfosActions.getInfoListSuccess, (state, { data }) => ({
    ...state,
    infoList: data.paging.pageNumber === 1 ? [...data.items] : [...state.infoList, ...data.items],
    paging: data.paging,
    isLoading: false
  })),
  on(TechInfosActions.getInfoListFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(TechInfosActions.getInfoListRefresh, (state, { data }) => ({
    ...state,
    infoList: [...data.items],
    paging: data.paging,
    isLoading: false
  })),
  on(TechInfosActions.postItemsMyRead, (state, data) => ({
    ...state,
    isLoading: false,
    isLoadingId: data.id
  })),
  on(TechInfosActions.postItemsMyReadSuccess, (state, { updatedItems, data }) => ({
      ...state,
      infoList: updatedItems,
      isLoadingId: undefined,
      isLoading: false
    })
  ),
  on(TechInfosActions.postItemsMyReadFail, (state) => ({
    ...state,
    isLoading: false
  }))
);
